export const EDUCATION_OPTIONS = [
    // Schooling
    "10th (Secondary School)",
    "12th (Higher Secondary)",
    "Diploma",
    "ITI (Industrial Training)",

    // Undergraduate Programs
    "B.Tech (Bachelor of Technology)",
    "B.E (Bachelor of Engineering)",
    "B.Sc (Bachelor of Science)",
    "BCA (Bachelor of Computer Applications)",
    "B.Com (Bachelor of Commerce)",
    "BBA (Bachelor of Business Administration)",
    "BA (Bachelor of Arts)",
    "B.Arch (Bachelor of Architecture)",
    "B.Des (Bachelor of Design)",
    "B.Pharm (Bachelor of Pharmacy)",
    "B.Ed (Bachelor of Education)",
    "B.Plan (Bachelor of Planning)",
    "LLB (Bachelor of Laws)",

    // Postgraduate Programs
    "M.Tech (Master of Technology)",
    "M.E (Master of Engineering)",
    "M.Sc (Master of Science)",
    "MCA (Master of Computer Applications)",
    "MBA (Master of Business Administration)",
    "M.Com (Master of Commerce)",
    "MA (Master of Arts)",
    "M.Arch (Master of Architecture)",
    "M.Des (Master of Design)",
    "M.Pharm (Master of Pharmacy)",
    "M.Ed (Master of Education)",
    "M.Plan (Master of Planning)",
    "LLM (Master of Laws)",
    "PGDM (Post Graduate Diploma in Management)",

    // Doctoral & Research
    "PhD (Doctor of Philosophy)",
    "M.Phil (Master of Philosophy)",
    "Post Doctorate",

    // Fallback
    "Others"
];

export const BRANCH_OPTIONS = [
    // Computer & IT
    "Computer Science & Engineering",
    "Information Engineering/Technology",
    "Artificial Intelligence & Machine Learning",
    "Data Science & Analytics",
    "Computer Applications (BCA/MCA)",
    "Cyber Security",
    "Cloud Computing",
    "Software Engineering",
    "Network Engineering",

    // Core Engineering
    "Mechanical Engineering",
    "Civil Engineering",
    "Electrical Engineering",
    "Electronics & Communication",
    "Aerospace & Aeronautical",
    "Automobile Engineering",
    "Chemical Engineering",
    "Biomedical Engineering",
    "Biotechnology",
    "Robotics & Automation",
    "Mechatronics",
    "Metallurgical Engineering",
    "Architecture",

    // Science & Mathematics
    "Mathematics",
    "Physics",
    "Chemistry",
    "Biology",
    "Environmental Science",
    "Statistics",

    // Business & Management
    "Business Administration",
    "Finance & Accounting",
    "Marketing Management",
    "Human Resources (HR)",
    "Operations Management",
    "Supply Chain & Logistics",
    "International Business",
    "Commerce",
    "Economics",

    // Arts, Humanities & Design
    "English Literature",
    "Psychology",
    "Sociology",
    "Political Science",
    "History",
    "Law (LLB/LLM)",
    "Graphic Design",
    "UI/UX Design",
    "Fashion Design",
    "Mass Communication & Journalism",

    // Fallback
    "Others"
];

export const TECHNICAL_DEGREES = [
    "B.Tech (Bachelor of Technology)",
    "B.E (Bachelor of Engineering)",
    "B.Sc (Bachelor of Science)",
    "BCA (Bachelor of Computer Applications)",
    "B.Arch (Bachelor of Architecture)",
    "M.Tech (Master of Technology)",
    "M.E (Master of Engineering)",
    "M.Sc (Master of Science)",
    "MCA (Master of Computer Applications)",
    "M.Arch (Master of Architecture)",
    "MBA (Master of Business Administration)",
    "PhD (Doctor of Philosophy)",
    "M.Phil (Master of Philosophy)",
    "Post Doctorate"
];
